import Head from 'next/head';
import { ContactForm } from '../components/ContactForm';

import { InlineWidget } from 'react-calendly';
import { Button } from '../components/Button';

export default function ContactPage() {
  const calendarUrl = process.env.NEXT_PUBLIC_CALENDLY_URL;
  return (
    <>
      <Head>
        <title>Contact | drive</title>
      </Head>
      <section className="contact-page">
        <div className="section-wrapper">
          <div className="contact-page-title">
            <h1>Schedule an online meeting</h1>
            <h3>We would love to hear from you!</h3>
            <InlineWidget
              url={`${calendarUrl}`}
              styles={{
                width: '600px',
                maxWidth: '600px',
                height: '805px',
                primaryColor: '17172f',
                textColor: '17172f',
                backgroundColor: 'f3f2f6',
              }}
              prefill={{
                email: 'your@email.com',
                firstName: 'Jon',
                lastName: 'Snow',
                name: 'Jon Snow',
                guests: ['janedoe@example.com', 'johndoe@example.com'],
              }}
            />
          </div>
        </div>

        <Button
          linkTo={'#contact-section'}
          title="Or send us a message"
          className={'btn-with-arrow-light-down contact-page-button'}
        />
      </section>

      <ContactForm />
    </>
  );
}
